import type { BodyUnitBody, GlobalOptions } from "@/utils/form-data-manager";

const normalize = (text?: string | null) => (text ?? "").trim().toLowerCase();

export const isSameText = (a?: string | null, b?: string | null) => normalize(a) === normalize(b);

// Option ids from any shape they are stored in: 1181, "1181", "1181,1182", [null, 1404]
export const toOptionIds = (value: unknown): string[] =>
  [value]
    .flat()
    .flatMap((item) => (item === null || item === undefined || item === "" ? [] : String(item).split(",")))
    .map((id) => id.trim())
    .filter(Boolean);

export const getBodyPicks = (body?: BodyUnitBody | null): GlobalOptions[] =>
  body?.global_picks_data?.global_picks ?? [];

export const picksHaveOption = (
  picks: GlobalOptions[],
  groupName: string,
  optionLabel: string,
): boolean =>
  picks.some(
    (pick) => isSameText(pick.group_name, groupName) && isSameText(pick.label, optionLabel),
  );

export const hasSelectedOption = (
  body: BodyUnitBody,
  groupName: string,
  optionLabel: string,
): boolean => picksHaveOption(getBodyPicks(body), groupName, optionLabel);
